<script>
    import user from "../stores/user.js";

    export let css = '';
</script>
{#if $user.token}
    <div class="pass-cards {css}">
        <a href="/wallet/index.php?key={ $user.hash }" target="_blank" class="mb-6">
            <img src="/assets/images/google-wallet.png" class="img-fluid" alt="google wallet">
        </a>
        <a href="/wallet/index.php?key={ $user.hash }" target="_blank">
            <img src="/assets/images/apple-wallet.png" class="img-fluid" alt="apple wallet">
        </a>
    </div>
{/if}
<style>
    .pass-cards {
        width: max-content;
        max-width: 100%;
        margin-left: auto;
        margin-right: auto;
    }

    .pass-cards a {
        display: block;
    }
</style>